import axios from 'axios';
import log from '../../logger';

/**
 * The tenant's plugin list.
 *
 * Replaces Angular's `pluginService`. That service also drove `oc.lazyLoad` and the
 * `module-loader` plugin, registering each plugin's Angular modules in dependency order;
 * SURF-4809 deleted all of it, because no plugin has shipped Angular since the Manage Assets
 * removal took the last `wysiwyg` directive. What is left is this fetch and the map built
 * from it, which is what a plugin page needs to read its own config.
 *
 * Fetched once per page load and cached, as `pluginService.initialize` was. A tenant switch
 * writes a cookie and reloads the page, so there is no in-session invalidation to worry about.
 */
let pending = null;

export function getPlugins() {
  if (!pending) {
    pending = axios
      .get('/plugins/plugins.json')
      .then(({ data }) => {
        const map = {};
        (data?.plugins || []).forEach((plugin) => {
          map[plugin.name] = plugin;
        });
        return map;
      })
      .catch((error) => {
        // The promise is cleared so a later navigation can retry rather than being stuck with
        // a rejected cache for the rest of the session. The Angular version alerted and left
        // `initializePromise` rejected forever, which meant every subsequent page was blank
        // with no way back short of a reload.
        pending = null;
        log.error('Failed to load the plugin list', error);
        throw new Error('Failed to load the plugin list.');
      });
  }
  return pending;
}

/** Test seam. Nothing in the app calls this. */
export function resetPluginsCache() {
  pending = null;
}
